import React, { Component, Suspense, lazy } from 'react'
import Sidebar from './Sidebar'
import { dataFetcher } from './../../utils/js/fetch_helpers'
import store from '../../store'
import { getStatsUrl } from '../../utils/js/endpoints'
import SuspenseLoader from './../../components/suspense_loader/SuspenseLoader'
import Feedback from '../../components/feedback/Feedback'

import './PlayerProfile.scss'

const NFLPlayerProfile = lazy(() => import('./nfl/NFLPlayerProfile'))
const MLBPlayerProfile = lazy(() => import('./mlb/MLBPlayerProfile'))
const NHLPlayerProfile = lazy(() => import('./nhl/NHLPlayerProfile'))
const NBAPlayerProfile = lazy(() => import('./nba/NBAPlayerProfile'))

class PlayerProfile extends Component {
    state = {
        player: {},
    }

    playerData = dataFetcher({
        key: 'player',
        name: 'player',
        responsePointer: 'data.data.player',
    })
    getPlayer = this.playerData.fire
    cancelPlayer = this.playerData.cancel

    componentDidMount() {
        this.analyticPageEvent()
        this.getPlayer(this.getFetchEndpoint(this.props.match.params.player_id))
    }

    componentDidUpdate(prevProps) {
        let old_player_id = prevProps.match.params.player_id
        let new_player_id = this.props.match.params.player_id

        if (old_player_id !== new_player_id && new_player_id) {
            this.analyticPageEvent()
            this.cancelPlayer() // kill any lingering requests
            this.getPlayer(this.getFetchEndpoint(new_player_id))
        }
    }

    componentWillUnmount() {
        this.cancelPlayer()
    }

    analyticPageEvent = () => {
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                sport: this.props.match.params.sport,
                league: this.props.match.params.league,
                page: 'player profile',
                url: window.location.href || document.URL,
            },
        })
    }

    getFetchEndpoint = player_id => {
        return `${getStatsUrl()}/web_player_profiles?league=${
            this.props.match.params.league
        }&player_id=${player_id}`
    }

    render() {
        const { player, isFetching_player, isError_player } = this.state
        const { sport, league, player_name, player_id } = this.props.match.params

        const player_props = {
            ...player,
            sport: sport,
            league: league,
            player_name: player_name,
            player_id: player_id,
            isFetching_player: isFetching_player,
            isError_player: isError_player,
        }

        const feedbackPerLeague = league => {
            const formIdPerLeague = new Map([
                ['mlb', '14751'],
                ['nhl', '14756'],
                ['nba', '14757'],
                ['cfl', '14759'],
                ['nfl', '14759'],
            ])

            const currentFormID = formIdPerLeague.get(league)
            return <Feedback formId={currentFormID} />
        }

        return (
            <div className={`PlayerProfile__cont ${league}`}>
                <div className="inner_cont">
                    <div className="left_col">
                        <Suspense fallback={<SuspenseLoader />}>
                            {league === 'mlb' && <MLBPlayerProfile {...player_props} />}
                            {league === 'nhl' && <NHLPlayerProfile {...player_props} />}
                            {league === 'nfl' && <NFLPlayerProfile {...player_props} />}
                            {league === 'nba' && <NBAPlayerProfile {...player_props} />}
                        </Suspense>
                    </div>
                    <div className="right_col">
                        <Sidebar
                            sport={sport}
                            league={league}
                            teamId={player?.team?.id}
                            teammates={player?.teammates}
                            salary={player?.salary}
                        />
                    </div>
                </div>
                {feedbackPerLeague(league)}
            </div>
        )
    }
}

export default PlayerProfile
